import { useEffect } from 'react'

import { CustomFormQuestionError } from 'components/tools/CustomForm/types'

type Params = {
  // questionMessageRequest?: string
  questionWithError: CustomFormQuestionError
  questionSlug?: string
}

export default function useCustomFormHandleErrorWithScrollBehavior({
  questionWithError,
  // questionMessageRequest = 'Este campo é obrigatório',
  questionSlug,
}: Params) {
  useEffect(() => {
    if (questionWithError?.error_message) {
      const element = document.getElementById(questionSlug as string)

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
    }
  }, [questionWithError])

  if (!questionWithError?.error_message) return

  return {}
}
